// @core/api/endpoints/project/add_item_to_component.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddItemToComponentRequest,
  ItemResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Add item to component
 * Assigns a project item to a component. Items can belong to multiple components.
 */
export async function AddItemToComponent(
  project_id: string,
  component_id: string,
  data: AddItemToComponentRequest,
  options?: RequestOptions
): Promise<ItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/components/:component_id/items`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':component_id', encodeURIComponent(component_id));
  const requestOptions = options;
  return client.post<ItemResponse>(requestPath, data, requestOptions);
}
